/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Link_Target_ContentiframeInputs */

const en_enum_link_target_contentiframe = /** @type {(inputs: Enum_Link_Target_ContentiframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show as iFrame in content area`)
};

const de_enum_link_target_contentiframe = /** @type {(inputs: Enum_Link_Target_ContentiframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als iFrame im Inhaltsbereich anzeigen`)
};

/**
* | output |
* | --- |
* | "Show as iFrame in content area" |
*
* @param {Enum_Link_Target_ContentiframeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_link_target_contentiframe = /** @type {((inputs?: Enum_Link_Target_ContentiframeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Link_Target_ContentiframeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_link_target_contentiframe(inputs)
	return de_enum_link_target_contentiframe(inputs)
});